import React from "react";
import Text from "./Text";

function BodyTextMedium({
  color,
  uppercase,
  underline,
  fontWeight,
  transition,
  children,
}) {
  return (
    <Text
      lineHeight={["26px", "26px", "32px", "32px"]}
      fontSize={[16, 16, 22, 22]}
      color={color}
      fontWeight={fontWeight}
      uppercase={uppercase}
      underline={underline}
      transition={transition}
      dangerouslySetInnerHTML={{ __html: children }}
    />
  );
}

export default BodyTextMedium;
